const localLocalesMap = {
  ua: 'uk',
  ch: 'zhCN',
  chtr: 'zhTW',
};

export default localLocalesMap;
